import { CommonModule } from "@angular/common";
import { Component, CUSTOM_ELEMENTS_SCHEMA, Input, OnInit } from "@angular/core";
import { TranslateModule, TranslateService } from "@ngx-translate/core";

@Component({
  selector: "app-customer-reference",
  templateUrl: "./customer-reference.component.html",
  imports: [TranslateModule, CommonModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CustomerReferenceComponent implements OnInit {
  @Input() isMobileView = false;
  @Input() advicedProduct: { name: string } | undefined;
  references: any[] = [];
  constructor(private translate: TranslateService) {}

  ngOnInit() {
    this.translate.get("ADVICE.CUSTOMER_REFERENCE.REFERENCES").subscribe((refs: any[]) => {
      this.references = [...refs, ...refs];
    });
  }
}
